"use strict";
/**
 * These types pertain to purchasable things that are NOT subscriptions e.g. one-time live games etc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseHistoryResponse = exports.PurchaseProductRequestResponse = exports.PurchaseableProductsResponse = exports.PurchaseableProduct = void 0;
var zod_openapi_1 = require("@anatine/zod-openapi");
var zod_1 = require("zod");
(0, zod_openapi_1.extendZodWithOpenApi)(zod_1.z);
exports.PurchaseableProduct = zod_1.z.object({
    product_id: zod_1.z.string(),
    product_name: zod_1.z.string().openapi({ example: 'Single Game Credit' }),
    price: zod_1.z.number().openapi({ example: 5.99 }),
    description: zod_1.z.string().default('Redeemable Credit'),
    app_channel_ids: zod_1.z.object({
        // Doing the transformation here bc the value might be null.
        // The true type of each of these is z.union([z.string(), z.null()])
        // however swagger gen does not generate correct swagger.json entry when that is used.
        amazon: zod_1.z
            .string()
            .optional()
            .transform(function (val) { return (val === null ? undefined : val); })
            .openapi({ example: 'example.com.amazon.fspt.annual' }),
        android: zod_1.z
            .string()
            .optional()
            .transform(function (val) { return (val === null ? undefined : val); })
            .openapi({ example: 'example.android.stag.fspt.annual' }),
        ios: zod_1.z
            .string()
            .optional()
            .transform(function (val) { return (val === null ? undefined : val); })
            .openapi({ example: 'example.apple.fspt.annual.test2' }),
        roku: zod_1.z
            .string()
            .optional()
            .transform(function (val) { return (val === null ? undefined : val); })
            .openapi({ example: 'example.roku.fspt.annual.test' })
    })
});
exports.PurchaseableProductsResponse = exports.PurchaseableProduct.array();
exports.PurchaseProductRequestResponse = zod_1.z.object({
    order_id: zod_1.z.string(),
    product_id: zod_1.z.string(),
    // TODO: update when UserProfileOutput has been converted to zod model
    user_profile: zod_1.z.any()
});
var PurchaseHistoryItemSchema = zod_1.z.object({
    status: zod_1.z.enum(['Available', 'Redeemed']).openapi({
        description: 'The status of the credit (Available or Redeemed)'
    }),
    description: zod_1.z.string().openapi({
        description: 'Description of the credit or redeemed item'
    }),
    date: zod_1.z.string().datetime().openapi({
        description: 'The date and time of the credit or redemption'
    }),
    credit_amount: zod_1.z.number().openapi({
        description: 'The number of credits redeemed'
    })
});
exports.PurchaseHistoryResponse = zod_1.z.object({
    available_credits: zod_1.z.number().int().openapi({
        description: 'The number of available credits'
    }),
    redemption_history: zod_1.z.array(PurchaseHistoryItemSchema).openapi({
        description: 'List of credits and redemptions with latest record first'
    })
});
